import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';
import { AdaCustomization } from '../models/ada-customization';
import { GameCustomizationsHandler } from './game-customizations-handler.interface';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class AdaCustomizationsService extends HttpDataService implements GameCustomizationsHandler {
  public list: AdaCustomization[];

  constructor(protected injector: Injector) {
    super(injector, '/customizations/ada');
  }

  loadCustomizationsCache(): Promise<AdaCustomization[]> {
    if (this.list) {
      return Promise.resolve(this.list);
    }
    return this.fetch({}).then((adaProducts) => (this.list = adaProducts['docs']));
  }

  getOptions(clientId: string): any[] {
    return this.list
      ? this.list
          .filter((customization) => customization.clientId === clientId)
          .map((customization) => ({ key: customization.id, value: customization.name }))
          .sort((a, b) => a.value.localeCompare(b.value))
      : [];
  }

  // TODO verify whether it is needed or can use getCustomization
  getCachedCustomization(id: string): AdaCustomization {
    const ret = this.list.find((customization) => customization.id === id);
    return ret;
  }

  getCustomization(id: string, populated = false): Promise<any> {
    let url = `${this.baseUrl}/${id}`;
    url = populated ? url + '/?populated=true' : url;
    return lastValueFrom(this.http.get(url, this.getRequestOptions())).catch((error) => this.handlePromiseError(error));
  }

  getCachedClientDefaultCustomization(clientId: string): AdaCustomization {
    return this.findCachedClientDefaultCustomization(clientId);
  }

  findCachedClientDefaultCustomization(clientId: string): AdaCustomization {
    let ret;
    if (this.list) {
      ret = this.list.find((customization) => customization.clientId === clientId && customization.defaultForClient);
    }
    return ret;
  }

  findLanguageDefaultCustomization(lang: string) {
    const url = `${this.baseUrl}/default/?language=${lang}`;
    return lastValueFrom(this.http.get(url, this.getRequestOptions()))
      .then((response) => response)
      .catch((error) => this.handlePromiseError(error));
  }
}
